import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_label_fi_item_default_by_category_hdr_RowClass } from '../../../dbschema';

export class LabelFiItemDefaultByCategoryHdrModel extends BaseContainerModel {
  bl_fi_mst_label_fi_item_default_by_category_hdr: bl_fi_mst_label_fi_item_default_by_category_hdr_RowClass = new bl_fi_mst_label_fi_item_default_by_category_hdr_RowClass();
}
